import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Validation from '../../Validation/Validation';
import commonStyles from '../formGroupsCommon.module.scss';

const ChangePasswordForm = ({ formProps }) => {
  const { t } = useTranslation();
  const { register, errors } = formProps;

  return (
    <div id={commonStyles.formGroupContainer}>
      <Form.Group className={commonStyles.formGroup}>
        <Form.Field width={8}>
          <label className={commonStyles.fieldLabel}>{t('privacyScreen.oldPass')}</label>
          <Validation name="oldPassword" errors={errors}>
            <input
              name="oldPassword"
              type="password"
              ref={register}
              autoComplete="off"
            />
          </Validation>
        </Form.Field>
      </Form.Group>
      <Form.Group className={commonStyles.formGroup}>
        <Form.Field width={8}>
          <label className={commonStyles.fieldLabel}>{t('privacyScreen.newPass')}</label>
          <Validation name="password" errors={errors}>
            <input
              name="password"
              type="password"
              ref={register}
              autoComplete="off"
            />
          </Validation>
          <div className={commonStyles.hint}>
            {t('changePassword.passwordHint')}
          </div>
        </Form.Field>
        <Form.Field width={8}>
          <label className={commonStyles.fieldLabel}>{t('privacyScreen.rptNewPass')}</label>
          <Validation name="repeatPassword" errors={errors}>
            <input
              name="repeatPassword"
              type="password"
              ref={register}
              autoComplete="off"
            />
          </Validation>
        </Form.Field>
      </Form.Group>
    </div>
  );
};

ChangePasswordForm.propTypes = {
  formProps: PropTypes.shape({
    register: PropTypes.func,
    errors: PropTypes.object,
    clearError: PropTypes.func,
    setValue: PropTypes.func,
    triggerValidation: PropTypes.func,
  }).isRequired,
};

export default ChangePasswordForm;
